import React from "react";
import privacybg from "../Assets/privacybg.png";
import { motion } from "framer-motion";

const Privacy = () => {
  return (
    <section
      className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white text-center"
      style={{
        backgroundImage: `url(${privacybg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="max-w-3xl mx-auto space-y-16"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        {/* Privacy and Data */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">
            PRIVACY AND DATA
          </h2>
          <p className="text-base sm:text-lg text-gray-200 max-w-full">
            Your security and privacy are non-negotiable. Non-custodial, you hold your keys. No personal data collected. Fully on-chain transparency. End-to-end protection powered by MonadScore.
          </p>
          <h3 className="text-xl sm:text-2xl font-semibold max-w-full">
            Your wallet. Your rules.
          </h3>
        </motion.div>

        {/* Community */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">
            COMMUNITY
          </h2>
          <p className="text-base sm:text-lg text-gray-200 max-w-full">
            Thousands of traders already use NTB to move faster and trade smarter. Join the trenches, get updates, and catch alpha early.
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Privacy;
